import _ from 'lodash/fp';
import { createReducer } from 'reduxsauce';
import { HITMANAGER, REQPROFILE_ID, USER_ID } from 'actions/Base';
import { lowerCaseAllWordsExceptFirstLetters } from "utils/helpers.js"

export const INITIAL_STATE = {
  studentToolbars: {},
  studentInfoLogs: {},
  reqProfiles: {
    content: {},
  },
  studentsInReqProfiles: {},
  nonUpdatedStudentsInReqProfiles: {},
  hitActions: [],
};

export const onGetStudentInfoRequest = (state) => ({ ...state, isLoading: true });
export const onGetStudentInfoFailure = (state) => ({ ...state, isLoading: false });
export const onGetStudentInfoSuccess = (state, { payload }) => {

  let current = _.cloneDeep(_.get(`studentToolbars[${USER_ID({ userType: 'STUDENT', id: payload.id })}]`)(state) || {});

  current = payload.response;

  state.isLoading = false
  return _.set(`studentToolbars.[${USER_ID({ userType: 'STUDENT', id: payload.id })}]`, current)(state);

};

export const onGetReqProfileRequest = (state) => ({ ...state, isLoading: true });
export const onGetReqProfileFailure = (state) => ({ ...state, isLoading: false });
export const onGetReqProfileSuccess = (state, { payload }) => {
  state.isLoading = false
  return _.set(`reqProfiles.content[${REQPROFILE_ID(payload)}]`, payload)(state);  
};

export const onGetReqProfilesRequest = (state) => ({ ...state, isLoading: true });
export const onGetReqProfilesFailure = (state) => ({ ...state, isLoading: false });
export const onGetReqProfilesSuccess = (state, { payload }) => {
  
  //  
  // We are merging objects to ensure we are not deleting data fetched by
  // onGetReqProfileSuccess, if we are not merging metadatas will be removed.
  //

  let current = { ...state.reqProfiles.content }
  let payloadContent = { ...payload.content } 

  // This iteration is needed to fix the keys in the fetched data so we can
  // merge them with the old data
  Object.keys(payloadContent).forEach(function(key) {
    // assign object property based on old property value
    payloadContent[REQPROFILE_ID(payloadContent[key])] = payloadContent[key]
    // delete old object property
    delete payloadContent[key];
  })

  current = _.merge(current, payloadContent)
  
  return {
    ...state,
    isLoading: false,
    reqProfiles: {
      ...state.reqProfiles,
      content: current,
      empty: payload.empty,
      first: payload.first,
      last: payload.last,
      number: payload.number,
      numberOfElements: payload.numberOfElements,
      pageable: payload.pageable,
      size: payload.size,
      sort: payload.sort,
      totalElements: payload.totalElements,
      totalPages: payload.totalPages
    }
  }
};


export const onCreateReqProfileRequest = (state) => ({ ...state, isLoading: true });
export const onCreateReqProfileFailure = (state) => ({ ...state, isLoading: false });
export const onCreateReqProfileSuccess = (state, { payload }) => {
  return _.set(`reqProfiles.content[${REQPROFILE_ID(payload)}]`, payload)(state);  
};

export const onGetStudentsInReqProfileRequest = (state) => ({ ...state, isLoading: true });
export const onGetStudentsInReqProfileFailure = (state) => ({ ...state, isLoading: false });
export const onGetStudentsInReqProfileSuccess = (state, { payload }) => {
  state.isLoading = false
  return _.set(`reqProfiles.content[${REQPROFILE_ID(payload.content[0].reqProfile)}].studentReqProfiles`, payload)(state);
};

export const onGetStudentsInReqProfilesRequest = (state) => ({ ...state, isLoading: true });
export const onGetStudentsInReqProfilesFailure = (state) => ({ ...state, isLoading: false });
export const onGetStudentsInReqProfilesSuccess = (state, { payload }) => {
  state.isLoading = false
  return _.set(`studentsInReqProfiles`, payload)(state);
};

export const onGetHitActionsRequest = (state) => ({ ...state, isLoading: true });
export const onGetHitActionsFailure = (state) => ({ ...state, isLoading: false });
export const onGetHitActionsSuccess = (state, { payload }) => {
  state.isLoading = false

  return _.set('hitActions', payload)(state);  
};

export const onGetStudentInfoLogRequest = (state) => ({ ...state, isLoading: true });
export const onGetStudentInfoLogFailure = (state) => ({ ...state, isLoading: false });
export const onGetStudentInfoLogSuccess = (state, { payload }) => {

  const { data, studentId } = payload;

  let current = _.cloneDeep(_.get(`studentInfoLogs[${USER_ID({ userType: 'STUDENT', id: studentId })}]`)(state) || {});

  current = data;

  state.isLoading = false

  return _.set(`studentInfoLogs[${USER_ID({ userType: 'STUDENT', id: studentId })}]`, current)(state);

};

export const onGetNonUpdatedStudentsInReqProfilesRequest = (state) => ({ ...state, isLoading: true });
export const onGetNonUpdatedStudentsInReqProfilesFailure = (state) => ({ ...state, isLoading: false });
export const onGetNonUpdatedStudentsInReqProfilesSuccess = (state, { payload }) => {
  state.isLoading = false
  return _.set(`nonUpdatedStudentsInReqProfiles`, payload)(state);
};

export const onSearchStudentsInReqProfilesRequest = (state) => ({ ...state, isLoading: true });
export const onSearchStudentsInReqProfilesFailure = (state) => ({ ...state, isLoading: false });
export const onSearchStudentsInReqProfilesSuccess = (state, { payload }) => {
  state.isLoading = false
  return _.set(`studentsInReqProfiles.page`, payload)(state);
};

export const onSearchStudentsInReqProfileRequest = (state) => ({ ...state, isLoading: true });
export const onSearchStudentsInReqProfileFailure = (state) => ({ ...state, isLoading: false });
export const onSearchStudentsInReqProfileSuccess = (state, { payload }) => {

  const current = _.cloneDeep(_.get(`reqProfiles.content[${REQPROFILE_ID({id: payload.reqProfileId })}]`)(state) || {});

  if (current) {
    current.studentReqProfiles = payload.data;

    state.isLoading = false
    return _.set(`reqProfiles.content[${REQPROFILE_ID({id: payload.reqProfileId })}]`, current)(state);

  }

  state.isLoading = false
  return state;
};

export const onAddStudentsToReqProfileRequest = (state) => ({ ...state, isLoading: true });
export const onAddStudentsToReqProfileFailure = (state) => ({ ...state, isLoading: false });
export const onAddStudentsToReqProfileSuccess = (state, { payload }) => {

  const reqProfile = payload.studentReqProfiles.content[0];

  return ({
    ...state,
    reqProfiles: {
      ...state.reqProfiles,
      content: {
        ...state.reqProfiles.content,
        [REQPROFILE_ID(payload)] : payload.studentReqProfiles
      }
    },
    studentToolbars: {
      ...state.studentToolbars,
      [USER_ID({ userType: 'STUDENT', id: payload.studentReqProfiles.content[0].student.studentId })] : {
        ...state.studentToolbars[USER_ID({ userType: 'STUDENT', id: payload.studentReqProfiles.content[0].student.studentId })],
        studentReqProfiles: state.studentToolbars[USER_ID({ userType: 'STUDENT', id: payload.studentReqProfiles.content[0].student.studentId })].studentReqProfiles.concat(reqProfile)
      }
    }
  })

};

export const onAddHitActionRequest = (state) => ({ ...state, isLoading: true });
export const onAddHitActionFailure = (state) => ({ ...state, isLoading: false });
export const onAddHitActionSuccess = (state, { payload }) => {
  const current = _.cloneDeep(_.get('hitActions.content')(state) || {});

  state.isLoading = false

  return _.set('hitActions.content', [payload, ...current])(state);  

};

export const onUpdateReqProfileRequest = (state) => ({ ...state });
export const onUpdateReqProfileFailure = (state) => ({ ...state });
export const onUpdateReqProfileSuccess = (state, { payload }) => { 
  return _.set(`reqProfiles.content[REQPROFILE-${payload.reqProfileId}]`, payload)(state);
};

export const onUpdateHitActionRequest = (state) => ({ ...state });
export const onUpdateHitActionFailure = (state) => ({ ...state });
export const onUpdateHitActionSuccess = (state, { payload }) => { 

  const hitActionIndex = state.hitActions.content.findIndex((hitAction) => (
    (hitAction || {}).id === payload.id
  ));
    
  if (hitActionIndex > -1) {
    return _.set(`hitActions.content[${hitActionIndex}]`, payload)(state);
  }

  return state;
};

// Update in reqProfile state
export const onUpdateStudentInReqProfileRequest = (state) => ({ ...state });
export const onUpdateStudentInReqProfileFailure = (state) => ({ ...state });
export const onUpdateStudentInReqProfileSuccess = (state, { payload }) => {
  const { response, oldStatus } = payload
  
  // Handle studentsInReqProfiles list
  let currentReqProfile = _.cloneDeep(_.get(`reqProfiles.content[REQPROFILE-${response.reqProfile.id}]`)(state) || {});

  if(currentReqProfile) {

  // Handle status dashboard
  if(oldStatus) {
    const oldStatusKey = 'numberOf' + lowerCaseAllWordsExceptFirstLetters(oldStatus)
    const newStatusKey = 'numberOf' + lowerCaseAllWordsExceptFirstLetters(response.studentReqProfileStatus)
    currentReqProfile[oldStatusKey] = --currentReqProfile[oldStatusKey]
    currentReqProfile[newStatusKey] = ++currentReqProfile[newStatusKey]
  }

  const studentInReqProfileIndex = currentReqProfile.studentReqProfiles.content.findIndex((student) => (
    (student || {}).studentReqProfileId === response.studentReqProfileId
  ));

  if(studentInReqProfileIndex > -1) {
    currentReqProfile.studentReqProfiles.content[studentInReqProfileIndex].updated = response.updated
    currentReqProfile.studentReqProfiles.content[studentInReqProfileIndex].rating = response.rating
    currentReqProfile.studentReqProfiles.content[studentInReqProfileIndex].flag = response.flag
    currentReqProfile.studentReqProfiles.content[studentInReqProfileIndex].studentReqProfileStatus = response.studentReqProfileStatus

    return _.set(`reqProfiles.content[REQPROFILE-${response.reqProfile.id}]`, currentReqProfile)(state);
    }

  }

  return state

};

// Update in nonUpdatedStudentsInReqProfiles state
export const onUpdateNonUpdatedStudentInReqProfileRequest = (state) => ({ ...state });
export const onUpdateNonUpdatedStudentInReqProfileFailure = (state) => ({ ...state });
export const onUpdateNonUpdatedStudentInReqProfileSuccess = (state, { payload }) => {
  const { response } = payload

  // Handle nonUpdatedStudentsInReqProfiles list
  let currentNonUpdatedStudentsInReqProfiles = _.cloneDeep(_.get(`nonUpdatedStudentsInReqProfiles`)(state) || {});

  if(currentNonUpdatedStudentsInReqProfiles) {

  const nonUpdatedStudentInReqProfileIndex = currentNonUpdatedStudentsInReqProfiles.content.findIndex((student) => (
    (student || {}).studentReqProfileId === response.studentReqProfileId
  ));

  if(nonUpdatedStudentInReqProfileIndex > -1) {
    currentNonUpdatedStudentsInReqProfiles.content[nonUpdatedStudentInReqProfileIndex].updated = response.updated
    currentNonUpdatedStudentsInReqProfiles.content[nonUpdatedStudentInReqProfileIndex].rating = response.rating
    currentNonUpdatedStudentsInReqProfiles.content[nonUpdatedStudentInReqProfileIndex].flag = response.flag
    currentNonUpdatedStudentsInReqProfiles.content[nonUpdatedStudentInReqProfileIndex].studentReqProfileStatus = response.studentReqProfileStatus

    return _.set(`nonUpdatedStudentsInReqProfiles`, currentNonUpdatedStudentsInReqProfiles)(state);
    }

  }

  return state

};

// Update in studentsInReqProfiles state (master list)
export const onUpdateStudentInReqProfilesSuccess = (state, { payload }) => {
  const { response, oldStatus } = payload

    if(oldStatus) {
      const oldStatusKey = 'numberOf' + lowerCaseAllWordsExceptFirstLetters(oldStatus)
      const newStatusKey = 'numberOf' + lowerCaseAllWordsExceptFirstLetters(response.studentReqProfileStatus)
      state.studentsInReqProfiles[oldStatusKey] = --state.studentsInReqProfiles[oldStatusKey]
      state.studentsInReqProfiles[newStatusKey] = ++state.studentsInReqProfiles[newStatusKey]
    }

    const studentIndex = state.studentsInReqProfiles.page.content.findIndex((student) => (
      (student || {}).studentReqProfileId === response.studentReqProfileId
    ));
    
    if (studentIndex > -1) {
      const current = _.get(`studentsInReqProfiles.page.content[${studentIndex}]`)(state) || {};

      if (current) {
        current.updated = response.updated
        current.rating = response.rating
        current.flag = response.flag
        current.studentReqProfileStatus = response.studentReqProfileStatus
        
        return _.set(`studentsInReqProfiles.page.content[${studentIndex}]`, current)(state);
      }

    }

  return state

};

// Delete from studentsInReqProfiles state (master list)
export const onDeleteStudentsFromReqProfileRequest = (state) => ({ ...state, isLoading: true });
export const onDeleteStudentsFromReqProfileFailure = (state) => ({ ...state, isLoading: false });
export const onDeleteStudentsFromReqProfileSuccess = (state, { payload }) => {

  state.isLoading = false

  // Remove from studentsInReqProfiles
  if(payload.reqProfileId) {
    const currentStudentInReqProfile = _.cloneDeep(_.get(`reqProfiles.content[REQPROFILE-${payload.reqProfileId}]studentReqProfiles.content`)(state) || {});

    payload.data.forEach(payloadObject => {
      currentStudentInReqProfile.splice(currentStudentInReqProfile.findIndex(object => object.studentReqProfileId === payloadObject.studentReqProfileId), 1);
    })

    return _.set(`reqProfiles.content[REQPROFILE-${payload.reqProfileId}]studentReqProfiles.content`, currentStudentInReqProfile)(state);  
  }

  return state;
  
};

// Delete from reqProfile state
export const onDeleteStudentsFromReqProfilesSuccess = (state, { payload }) => {

  state.isLoading = false

  // Remove from studentsInReqProfiles
  if(!payload.studentId) {
    const nonUpdatedStudentsInReqProfiles = _.cloneDeep(_.get(`nonUpdatedStudentsInReqProfiles.content`)(state) || {});

    payload.data.forEach(payloadObject => {
      nonUpdatedStudentsInReqProfiles.splice(nonUpdatedStudentsInReqProfiles.findIndex(object => object.studentReqProfileId === payloadObject.studentReqProfileId), 1);
    })

    return _.set('nonUpdatedStudentsInReqProfiles.content', nonUpdatedStudentsInReqProfiles)(state);  
  }

  // Remove from hitManager.studentToolbars
  if(payload.studentId) {
    const currentStudentToolbar = _.cloneDeep(_.get(`studentToolbars[${USER_ID({ userType: 'STUDENT', id: payload.studentId })}]`)(state) || {});

    if (currentStudentToolbar) {
      payload.data.forEach(payloadObject => {
        currentStudentToolbar.studentReqProfiles.splice(currentStudentToolbar.studentReqProfiles.findIndex(object => object.studentReqProfileId === payloadObject.studentReqProfileId), 1);
      })

      return _.set(`studentToolbars[${USER_ID({ userType: 'STUDENT', id: payload.studentId })}]`, currentStudentToolbar)(state);  
    }
  }

  return state;
  
};

export const onDeleteReqProfileRequest = (state) => ({ ...state, isLoading: true });
export const onDeleteReqProfileFailure = (state) => ({ ...state, isLoading: false });
export const onDeleteReqProfileSuccess = (state, { payload }) => {
  state.isLoading = false

  // Remove from studentsInReqProfiles
  if(payload.reqProfileId) {
    const currentReqProfiles = _.cloneDeep(_.get(`reqProfiles.content`)(state) || {});

    delete currentReqProfiles[`REQPROFILE-${payload.reqProfileId}`]

    return _.set(`reqProfiles.content`, currentReqProfiles)(state);  
  }

  return state;  
}

export const onDeleteHitActionRequest = (state) => ({ ...state, isLoading: true });
export const onDeleteHitActionFailure = (state) => ({ ...state, isLoading: false });
export const onDeleteHitActionSuccess = (state, { payload }) => {

  // Remove from hitActionsList
  if(payload.hitActionId) {

    const currentHitActions = _.cloneDeep(_.get(`hitActions.content`)(state) || {});
    const index = currentHitActions.findIndex(obj => obj.hitActionId === payload.hitActionId);

    const newHitActions = [
        ...currentHitActions.slice(0, index),
        ...currentHitActions.slice(index + 1)
    ]

    state.isLoading = false

    return _.set(`hitActions.content`, newHitActions)(state);  
  }

  return state;  
}

export const onResetRequest = () => INITIAL_STATE;

export const ACTION_HANDLERS = {
  [HITMANAGER.GET_STUDENTINFO_REQUEST]: onGetStudentInfoRequest,
  [HITMANAGER.GET_STUDENTINFO_FAILURE]: onGetStudentInfoFailure,
  [HITMANAGER.GET_STUDENTINFO_SUCCESS]: onGetStudentInfoSuccess,

  [HITMANAGER.GET_REQPROFILE_REQUEST]: onGetReqProfileRequest,
  [HITMANAGER.GET_REQPROFILE_FAILURE]: onGetReqProfileFailure,
  [HITMANAGER.GET_REQPROFILE_SUCCESS]: onGetReqProfileSuccess,

  [HITMANAGER.GET_REQPROFILES_REQUEST]: onGetReqProfilesRequest,
  [HITMANAGER.GET_REQPROFILES_FAILURE]: onGetReqProfilesFailure,
  [HITMANAGER.GET_REQPROFILES_SUCCESS]: onGetReqProfilesSuccess,

  [HITMANAGER.CREATE_REQPROFILE_REQUEST]: onCreateReqProfileRequest,
  [HITMANAGER.CREATE_REQPROFILE_FAILURE]: onCreateReqProfileFailure,
  [HITMANAGER.CREATE_REQPROFILE_SUCCESS]: onCreateReqProfileSuccess,

  [HITMANAGER.GET_STUDENTS_IN_REQPROFILE_REQUEST]: onGetStudentsInReqProfileRequest,
  [HITMANAGER.GET_STUDENTS_IN_REQPROFILE_FAILURE]: onGetStudentsInReqProfileFailure,
  [HITMANAGER.GET_STUDENTS_IN_REQPROFILE_SUCCESS]: onGetStudentsInReqProfileSuccess,

  [HITMANAGER.GET_STUDENTS_IN_REQPROFILES_REQUEST]: onGetStudentsInReqProfilesRequest,
  [HITMANAGER.GET_STUDENTS_IN_REQPROFILES_FAILURE]: onGetStudentsInReqProfilesFailure,
  [HITMANAGER.GET_STUDENTS_IN_REQPROFILES_SUCCESS]: onGetStudentsInReqProfilesSuccess,

  [HITMANAGER.GET_NONUPDATED_STUDENTS_IN_REQPROFILES_REQUEST]: onGetNonUpdatedStudentsInReqProfilesRequest,
  [HITMANAGER.GET_NONUPDATED_STUDENTS_IN_REQPROFILES_FAILURE]: onGetNonUpdatedStudentsInReqProfilesFailure,
  [HITMANAGER.GET_NONUPDATED_STUDENTS_IN_REQPROFILES_SUCCESS]: onGetNonUpdatedStudentsInReqProfilesSuccess,

  [HITMANAGER.GET_HITACTIONS_REQUEST]: onGetHitActionsRequest,
  [HITMANAGER.GET_HITACTIONS_FAILURE]: onGetHitActionsFailure,
  [HITMANAGER.GET_HITACTIONS_SUCCESS]: onGetHitActionsSuccess,

  [HITMANAGER.GET_STUDENT_INFO_LOG_REQUEST]: onGetStudentInfoLogRequest,
  [HITMANAGER.GET_STUDENT_INFO_LOG_FAILURE]: onGetStudentInfoLogFailure,
  [HITMANAGER.GET_STUDENT_INFO_LOG_SUCCESS]: onGetStudentInfoLogSuccess,

  [HITMANAGER.SEARCH_STUDENTS_IN_REQPROFILES_REQUEST]: onSearchStudentsInReqProfilesRequest,
  [HITMANAGER.SEARCH_STUDENTS_IN_REQPROFILES_FAILURE]: onSearchStudentsInReqProfilesFailure,
  [HITMANAGER.SEARCH_STUDENTS_IN_REQPROFILES_SUCCESS]: onSearchStudentsInReqProfilesSuccess,

  [HITMANAGER.SEARCH_STUDENTS_IN_REQPROFILE_REQUEST]: onSearchStudentsInReqProfileRequest,
  [HITMANAGER.SEARCH_STUDENTS_IN_REQPROFILE_FAILURE]: onSearchStudentsInReqProfileFailure,
  [HITMANAGER.SEARCH_STUDENTS_IN_REQPROFILE_SUCCESS]: onSearchStudentsInReqProfileSuccess,

  [HITMANAGER.ADD_STUDENT_REQPROFILE_REQUEST]: onAddStudentsToReqProfileRequest,
  [HITMANAGER.ADD_STUDENT_REQPROFILE_FAILURE]: onAddStudentsToReqProfileFailure,
  [HITMANAGER.ADD_STUDENT_REQPROFILE_SUCCESS]: onAddStudentsToReqProfileSuccess,

  [HITMANAGER.ADD_HITACTION_REQUEST]: onAddHitActionRequest,
  [HITMANAGER.ADD_HITACTION_FAILURE]: onAddHitActionFailure,
  [HITMANAGER.ADD_HITACTION_SUCCESS]: onAddHitActionSuccess,

  [HITMANAGER.UPDATE_HITACTION_REQUEST]: onUpdateHitActionRequest,
  [HITMANAGER.UPDATE_HITACTION_FAILURE]: onUpdateHitActionFailure,
  [HITMANAGER.UPDATE_HITACTION_SUCCESS]: onUpdateHitActionSuccess, 

  [HITMANAGER.UPDATE_REQPROFILE_REQUEST]: onUpdateReqProfileRequest,
  [HITMANAGER.UPDATE_REQPROFILE_FAILURE]: onUpdateReqProfileFailure,
  [HITMANAGER.UPDATE_REQPROFILE_SUCCESS]: onUpdateReqProfileSuccess, 

  // Update reqProfile state
  [HITMANAGER.UPDATE_STUDENT_REQPROFILE_REQUEST]: onUpdateStudentInReqProfileRequest,
  [HITMANAGER.UPDATE_STUDENT_REQPROFILE_FAILURE]: onUpdateStudentInReqProfileFailure,
  [HITMANAGER.UPDATE_STUDENT_REQPROFILE_SUCCESS]: onUpdateStudentInReqProfileSuccess,

  // Update master list and nonUpdatedStudent list
  [HITMANAGER.UPDATE_STUDENT_REQPROFILES_SUCCESS]: onUpdateStudentInReqProfilesSuccess,
  [HITMANAGER.UPDATE_NON_UPDATED_STUDENT_REQPROFILES_SUCCESS]: onUpdateNonUpdatedStudentInReqProfileSuccess,

  // Delete from reqProfile state
  [HITMANAGER.DELETE_STUDENTS_REQPROFILE_REQUEST]: onDeleteStudentsFromReqProfileRequest,
  [HITMANAGER.DELETE_STUDENTS_REQPROFILE_FAILURE]: onDeleteStudentsFromReqProfileFailure,
  [HITMANAGER.DELETE_STUDENTS_REQPROFILE_SUCCESS]: onDeleteStudentsFromReqProfileSuccess,

  // Delete from master list
  [HITMANAGER.DELETE_STUDENTS_REQPROFILES_SUCCESS]: onDeleteStudentsFromReqProfilesSuccess,

  [HITMANAGER.DELETE_REQPROFILE_REQUEST]: onDeleteReqProfileRequest,
  [HITMANAGER.DELETE_REQPROFILE_FAILURE]: onDeleteReqProfileFailure,
  [HITMANAGER.DELETE_REQPROFILE_SUCCESS]: onDeleteReqProfileSuccess,

  [HITMANAGER.DELETE_HITACTION_REQUEST]: onDeleteHitActionRequest,
  [HITMANAGER.DELETE_HITACTION_FAILURE]: onDeleteHitActionFailure,
  [HITMANAGER.DELETE_HITACTION_SUCCESS]: onDeleteHitActionSuccess,
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
